import * as React from 'react';

import footer from 'components/lexemes/footer';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

import AppLinks from 'components/app-links/app-links';
import FeatureCtaHeader from 'components/feature-cta/feature-cta-header';

type Props = {
  title: string;
  titleLang?: SupportedLanguage;
  appLinks?: boolean;
  onAppleStoreClick?: () => void;
  onGoogleStoreClick?: () => void;
};

const FeatureCta: React.FunctionComponent<Props> = ({
  title,
  titleLang,
  appLinks = true,
  onAppleStoreClick,
  onGoogleStoreClick,
}) => {
  return (
    <div className="page-feature-cta__container button--cta-sign-in">
      <div className="page-feature-cta__body">
        <FeatureCtaHeader lang={titleLang}> {title}</FeatureCtaHeader>
        {appLinks && (
          <AppLinks
            onAppleStoreClick={onAppleStoreClick}
            onGoogleStoreClick={onGoogleStoreClick}
            description={footer.lxDownloadCopyText()}
            isTextCenter={true}
            isCta={true}
          />
        )}
      </div>
    </div>
  );
};

export default FeatureCta;
